import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FreshAuthService } from '../fresh-auth.services';
import { UntypedFormControl, UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { environment as ENV } from '../../../environments/environment';
import { environment } from '../../../environments/environment.ubi';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../../admin/admin.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AddCustomerService } from '../../admin/add-customer.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
import * as constants from '../../../app/constant';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';


@Component({
  selector: 'wl-view-review-journey', 
  providers: [AddCustomerService, AdminService],
  templateUrl: './view-review-journey.component.html',
  styleUrls: ['./view-review-journey.component.scss'],
})
export class ViewreviewJourneyComponent implements OnInit {
  noUserFound: string;
  search = new UntypedFormControl();
  searchHolder: string;
  showSelectedDate: boolean;
  currentDate: String;
  selectedDate: any;
  pageId = 1;
  page: number = 1;
  totalPage: number = 1;
  allUsers: any;

  public incompleteJrnyForm: UntypedFormGroup;
  kccNewUat: string = environment.kccNewUat;
  loading: boolean;
  filterTableDate = new Date();
  @ViewChild('date1') firstDate: ElementRef;
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  limit: number = 10;
  offset: number = 0;
  failureMapping = {
    cfd_status: 'status',
    // generate_aadhar: 'aadhar_response',
    // kcc_account_fetched: 'overall_status',
    land_bre_status: 'land_bre_status',
    land_geomapping: 'response',
    // verify_aadhar: 'aadhar_response',
    cic: {
      cibil: 'npaStatus',
      experian: 'npaStatus',
    },
    
  };
  totalCount: any;
  iscredCount: any;
  showOrHide: boolean;

  display: boolean;
  roleId: number;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showReviewInboxDataTable: boolean = true;
  filter: string = "";
  isOD: boolean;
  isTN: boolean;
  adminId:string = sessionStorage.getItem('wl-admin-id');

  approvalStage: string = '';


  private captureApprovalStage(res: any) {
    const stage = (res && res.approvalStage) || '';
    this.approvalStage = String(stage).trim().toLowerCase();
  }

  constructor(
    private freshAuthService: FreshAuthService,
    private customer: FreshAuthService,
    private _fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private advancedFilterService: AdvancedFilterService,
    private dialog: MatDialog,
    private router: Router,
    private addCustomer: AddCustomerService
  ) {

    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }

    this.searchHolder = 'Search Applicant by Name';

    this.display = false;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.pageId = 1;
    this.page = 1;
    this.loading = true;
    this.customer.getReviewInboxUsers(value, 1, 0, 10).subscribe(
      (res) => {
        this.loading = false;
        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData || [];
          this.totalCount = res.result.count || 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.captureApprovalStage(res);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      (err) => {
        this.totalCount = 0;
        this.totalPage = 0;
        this.loading = false;
        throw err;
      }
    );
  }
  onChildClosed() {
  this.getData();
}

  ngOnInit() {
    
    
    console.log('Review Component Service Instance:', this.addCustomer);
    this.roleId = +this.freshAuthService.getRoleId();
    if (this.isCoLogin()) {
      this.showReviewInboxDataTable = false;
    }
    sessionStorage.removeItem('filterDateReviewInboxStart');
    sessionStorage.removeItem('filterDateReviewInboxEnd');
    this.maxDate = this.freshAuthService.getCurrentMonth();
    !this.isCoLogin() && this.getData();

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    if (constants.STATES.OD.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase())) {
      this.isOD = true;
    } else if (constants.STATES.TN.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase())) {
      this.isTN = true;
    } else {
      this.isOD = false;
      this.isTN = false;
    }
  }

  getData() {
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    this.freshAuthService
      .loan_Review_Inbox_jrny(
        admin_id,
        1,
        '',
        0,
        10,
        'review',
        branch_code,
        ro_code,
        zonal_code
      )
      .subscribe(
        (res) => {
          this.loading = false;
          console.log(res, 'hello');
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.allUsers = res.resultData ? res.resultData : [];
          this.captureApprovalStage(res);
          // this.getApplicationStatus();

          
          console.log(this.allUsers.map((user) => user.newFailureArray));
        },
        (err) => {
          this.loading = false;
          throw err;
        }
      );
  }

  getAppStatusMessage(appStatus, trackerObj) {

    if (!appStatus) {
      if (!trackerObj.journey_tracker.verify_aadhar) {
        appStatus = "Aadhar Verification Pending";
      } else if (!trackerObj.journey_tracker.cic) {
        appStatus = "CIC Verification Pending/ CIC report not generated";
      } else if (!trackerObj.journey_tracker.verify_panvoter) {
        appStatus = "PAN/Voter Verification Pending"
      } else {
        appStatus = this.getIncompleteAppStatus(trackerObj);
      }
    }

   

  }

  getIncompleteAppStatus(trackerObj) {
    let appStatus;

    let journeyTracker = trackerObj.journey_tracker;

    if (journeyTracker.verify_aadhar.name_match === 'pending') {
      appStatus = "Aadhar Verification Pending";
    } else if (journeyTracker.cicreport.cibil.npaStatus === 'pending') {
      appStatus = "CIC Verification Pending/ CIC report not generated";
    } else if (journeyTracker.verify_panvoter.name_match === 'pending') {
      appStatus = "PAN/Voter Verification Pending"
    } else {
      appStatus = "Incomplete Journey"
    }

    return appStatus;
  }


  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, 'review').subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        this.allUsers = res && res.result && res.result.resultData ? res.result.resultData : [];
        this.captureApprovalStage(res);

        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);

      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateReviewInboxStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateReviewInboxEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getReviewInoboxUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.captureApprovalStage(res);
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            }
          } else {
            // this.allUsers = this.getEmptyArray()
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateReviewInboxStart');
    sessionStorage.removeItem('filterDateReviewInboxEnd');
    sessionStorage.removeItem('filterDateSanction');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }
  ngOnDestroy() {
    console.log('foo destroy');
    sessionStorage.removeItem('filterDateReviewInboxStart');
    sessionStorage.removeItem('filterDateReviewInboxEnd');
  }

  isCoLogin() {
    if (this.roleId === 1) {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showReviewInboxDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    try {
      this.freshAuthService.getReviewInboxJourneys(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          this.allUsers = response && response.resultData ? response.resultData : [];
          this.captureApprovalStage(response);
          if (!this.allUsers.length) {
            this.noUserFound = 'Customer data not found';
          } else {
            // this.getApplicationStatus();
          }
          this.totalCount = response && response.count ? response.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }

  openValidateDialog(user: any) {
    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: '400px',
      height: '150px',
      data: {
        heading: "",
        content: "Please confirm before accepting.",
        content1: "",
        button1Text: "Accept",
        button2Text: "Reject"
      }
    });

    dialogRef.afterOpened().subscribe(() => {

      // pick the dialog container of THIS dialog (not other dialogs)
      const container = document.querySelector('mat-dialog-container');
      if (!container) return;

      const contentParagraph = container.querySelector('p');

      const checkboxDiv = document.createElement('div');
      checkboxDiv.style.marginTop = "15px";
      checkboxDiv.innerHTML = `
    <label style="cursor:pointer; font-size:14px;">
      <input id="verifyCheck" type="checkbox" />
      I confirm the information is correct
    </label>
  `;

      contentParagraph.appendChild(checkboxDiv);

      // Accept button (blue button)
      const buttons = container.querySelectorAll('button');
      const acceptBtn = buttons[0] as HTMLButtonElement;

      // Disable accept initially
      acceptBtn.disabled = true;
      acceptBtn.style.opacity = "0.5";

      const checkbox = document.getElementById('verifyCheck') as HTMLInputElement;

      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          acceptBtn.disabled = false;
          acceptBtn.style.opacity = "1";
        } else {
          acceptBtn.disabled = true;
          acceptBtn.style.opacity = "0.5";
        }
      });
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === "dontClose") {
        user.action = "verify";
      } else if (result === "close") {
        user.action = "rejected";
      }
    });
  }

  validateCustomer(user: any) {

  // setItem stringifies whatever it is given, so a missing custId would be
  // stored as the literal "undefined" and printed as such on the card.
  sessionStorage.setItem('selectedCustId', user.custId || '');
  sessionStorage.setItem(
    'selectedMobileNo',
    user.mobile_no || (user.aadhar_details && user.aadhar_details.mobile_number) || ''
  );
  sessionStorage.setItem('selectedName', user.profile.first_name);
  // sessionStorage.setItem('selectedStatus', user.Journey_Status);
  sessionStorage.setItem('selectedId',user.id)
  sessionStorage.setItem('maker_status',user.makerStatus)
  this.router.navigate(['/fresh-app/view-validation-customer']);

}

}


